import { render, staticRenderFns } from "./objectGroupSet.vue?vue&type=template&id=c47e6418"
import script from "./objectGroupSet.vue?vue&type=script&lang=js"
export * from "./objectGroupSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47e6418')) {
      api.createRecord('c47e6418', component.options)
    } else {
      api.reload('c47e6418', component.options)
    }
    module.hot.accept("./objectGroupSet.vue?vue&type=template&id=c47e6418", function () {
      api.rerender('c47e6418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectGroupSet.vue"
export default component.exports